module.exports = __webpack_public_path__ + "static/live-intro3-32f381f7b1acb27d48cda3d6f6fff403.jpg";